import { GroupOperationError } from '@shure/cloud/shared/models/devices';

import { GroupOperationError as SysApiGroupOperationError } from '../graphql/generated/cloud-sys-api';

export function mapGroupOperationErrorFromSysApi(
	error: SysApiGroupOperationError | null | undefined
): GroupOperationError | undefined {
	if (!error) {
		return undefined;
	}

	switch (error) {
		case SysApiGroupOperationError.DeviceNotFound:
			return GroupOperationError.DeviceNotFound;
		case SysApiGroupOperationError.GroupNameInvalid:
			return GroupOperationError.GroupNameInvalid;
		case SysApiGroupOperationError.GroupNameNotUnique:
			return GroupOperationError.GroupNameNotUnique;
		case SysApiGroupOperationError.GroupNotEmpty:
			return GroupOperationError.GroupNotEmpty;
		case SysApiGroupOperationError.GroupNotFound:
			return GroupOperationError.GroupNotFound;
		case SysApiGroupOperationError.MaxGroupsLimitReached:
			return GroupOperationError.MaxGroupsLimitReached;
		case SysApiGroupOperationError.OrgTreeDepthLimitReached:
			return GroupOperationError.OrgTreeDepthLimitReached;
		case SysApiGroupOperationError.OrgTreeWouldBeInvalid:
			return GroupOperationError.OrgTreeWouldBeInvalid;
		case SysApiGroupOperationError.SpaceNotFound:
			return GroupOperationError.SpaceNotFound;
		case SysApiGroupOperationError.Unknown:
			return GroupOperationError.Unknown;
		default:
			// TODO (carlsos): Add back exhaustive compile-time checking when RoomNotFound is removed from the SysApiGroupOperationError enum
			return GroupOperationError.Unknown;
	}
}
